<template>
  <section class="sc-schedule">
    <div class="sc-schedule-inner">
      <!-- header 条 蓝色 -->
      <div class="sc-schedule-header">
        <div class="sc-schedule-header-pattern" />
        <div class="sc-schedule-header-content">
          <span class="header-text-yellow">Half Day Camp</span>
          <span class="header-text-white"> Schedule</span>
        </div>
      </div>

      <!-- 两栏：Morning / Afternoon -->
      <div class="sc-schedule-body">
        <!-- Morning 左栏 -->
        <div class="sc-schedule-col sc-schedule-col--blue">
          <div class="sc-col-heading">
            <span class="sc-col-dot sc-col-dot--blue" />
            <span class="sc-col-title sc-col-title--blue">Morning Camp Schedule</span>
          </div>
          <div class="sc-schedule-rows">
            <div v-for="row in morningRows" :key="row.time" class="sc-schedule-row sc-schedule-row--morning">
              <div class="sc-row-time">
                {{ row.time }}
              </div>
              <div class="sc-row-activity" :class="{ 'is-bold': row.bold }">
                {{ row.activity }}
              </div>
            </div>
          </div>
        </div>

        <!-- Afternoon 右栏 -->
        <div class="sc-schedule-col sc-schedule-col--purple">
          <div class="sc-col-heading">
            <span class="sc-col-dot sc-col-dot--purple" />
            <span class="sc-col-title sc-col-title--purple">Afternoon Camp Schedule</span>
          </div>
          <div class="sc-schedule-rows">
            <div v-for="row in afternoonRows" :key="row.time" class="sc-schedule-row sc-schedule-row--afternoon">
              <div class="sc-row-time" :class="{ 'text-red': row.red }">
                {{ row.time }}
              </div>
              <div class="sc-row-activity" :class="{ 'is-bold': row.bold }">
                {{ row.activity }}
              </div>
            </div>
            <!-- Extended Care 横跨整行 -->
            <div class="sc-schedule-row sc-schedule-row--extended">
              <div class="sc-row-extended">
                <span class="sc-row-extended-time">4:00-5:00</span>
                <span class="sc-row-extended-label">Extended Care（$75/week)</span>
              </div>
            </div>
          </div>
          <p class="sc-schedule-note">
            Students must be dropped off and picked up within their scheduled camp hours;
            early drop-off is not permitted, and late pick-up will incur a <strong>$1 per minute</strong> fee.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SummerCampSchedule',
  data() {
    return {
      morningRows: [
        { time: '9:00-9:30', activity: 'Drop Off', bold: true },
        { time: '9:30-10:25', activity: 'Math', bold: true },
        { time: '10:25-10:35', activity: 'Break', bold: true },
        { time: '10:35-11:30', activity: 'English', bold: true },
        { time: '11:30-11:50', activity: 'Play Time & Pick Up', bold: true },
      ],
      afternoonRows: [
        { time: '1:00-1:30', activity: 'Drop Off', bold: true },
        { time: '1:30-2:25', activity: 'Math', bold: true },
        { time: '2:25-2:35', activity: 'Break', bold: true },
        { time: '2:35-3:30', activity: 'English', bold: true },
        { time: '3:30-3:50', activity: 'Play Time & Pick Up', bold: true },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sc-schedule {
  padding-bottom: 100px;
  background: #fff;
  font-family: 'Roboto-Flex', sans-serif;

  .sc-schedule-inner {
    max-width: 1280px;
    margin: 0 auto;
    border-radius: 20px;
    overflow: hidden;
  }

  // 蓝色 header 条
  .sc-schedule-header {
    position: relative;
    height: 90px;
    background: #629eed;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px 20px 0 0;

    .sc-schedule-header-pattern {
      position: absolute;
      inset: 0;
      background-image: url('~assets/web/images/summerCamp/schedule-title-bg.png');
      background-size: cover;
      background-position: center;
      transform-origin: center;
    }

    .sc-schedule-header-content {
      position: relative;
      z-index: 1;
      font-size: 36px;
      font-weight: 700;
      line-height: 30px;
      font-family: 'Roboto-Bold', sans-serif;

      .header-text-yellow { color: #ffd400; }
      .header-text-white { color: #fff; }
    }
  }

  // 两栏布局
  .sc-schedule-body {
    display: flex;
    min-height: 587px;
    gap: 26px;
  }

  .sc-schedule-col {
    flex: 1;
    padding: 30px 22px 30px 22px;
    display: flex;
    flex-direction: column;
    gap: 0;

    &--blue {
      background: #e8f2ff;
      border-radius: 0 0 20px 0;

      .sc-schedule-rows { gap: 25px; }
    }
    &--purple {
      background: #efefff;
      border-radius: 0 0 0 20px;

      .sc-schedule-rows { gap: 20px; }
    }
  }

  .sc-col-heading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 24px;
    padding-left: 10px;

    .sc-col-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      flex-shrink: 0;

      &--blue { background: #4a7aba; }
      &--purple { background: #3d3e81; }
    }

    .sc-col-title {
      font-size: 32px;
      font-weight: 600;
      line-height: 42px;
      text-transform: capitalize;

      &--blue { color: #4a7aba; }
      &--purple { color: #3d3e81; }
    }
  }

  .sc-schedule-rows {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .sc-schedule-row {
    display: flex;
    gap: 16px;

    .sc-row-time,
    .sc-row-activity {
      background: #fff;
      border-radius: 10px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 500;
      color: #44454c;
      letter-spacing: 0.54px;
      white-space: nowrap;
    }

    &.sc-schedule-row--morning {
      .sc-row-time,
      .sc-row-activity {
        height: 60px;
      }
    }

    .sc-row-time {
      flex: 1;
    }

    .sc-row-activity {
      flex: 1;

      &.is-bold {
        font-weight: 700;
      }
    }

    &.sc-schedule-row--extended {
      .sc-row-extended {
        width: 100%;
        background: #fff;
        border-radius: 10px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;

        .sc-row-extended-time {
          font-size: 18px;
          font-weight: 700;
          color: var(--txt-color-link);
          letter-spacing: 0.54px;
          white-space: nowrap;
        }

        .sc-row-extended-label {
          font-size: 18px;
          font-weight: 700;
          color: var(--txt-color-link);
          letter-spacing: 0.54px;
          white-space: nowrap;
        }
      }
    }

    .text-red {
      color: var(--txt-color-link);
      font-weight: 700;
    }
  }

  .sc-schedule-note {
    margin-top: 16px;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    color: #4a4a4a;
    text-transform: capitalize;

    strong { font-weight: 700; }
  }
}
</style>
